export default "__VITE_ASSET__BEUh3SUr__"